/**
 * 商业化部署约定：与 new-api 后台 `ServerAddress`、对外品牌入口保持一致（无尾斜杠）。
 * 管理端仅展示，不在此页面编辑，避免误配。
 */
export const FIXED_PUBLIC_SITE_ORIGIN = 'https://tokentcp.com'
